/* eslint-disable */
import router from "@/router/index.js";
import axiosInstance from "@/composables/axios-instance.js";
import { toast } from "vue3-toastify";
import VueCookies from "vue-cookies";

// state
const state = {
  registerErr: {},
  IsAuthenticated: false,
  isDark: false,
  rememberMe: false,
  checkRedirect:false,
  needRedirect:false,
  redirectUrl: null,
  loginErr: {},
  changePassErr: {},
  userData: {},
  usersList: {},
  username: {},
};

// getters
const getters = {
  getRegisterErr(state) {
    return state.registerErr;
  },
  getIsAuthenticated(state) {
    return state.IsAuthenticated;
  },
  getCheckRedirect(state){
    return state.checkRedirect;
  },
  getNeedRedirect(state){
    return state.needRedirect;
  },
  getRedirectUrl(state){
    return state.redirectUrl;
  },
  getLoginErr(state) {
    return state.loginErr;
  },
  getChangePassErr(state) {
    return state.changePassErr;
  },
  getUserData(state) {
    return state.userData;
  },
  getDarkMode(state) {
    return state.isDark;
  },
  getUsersList(state){
    return state.usersList;
  },
  getUsername(state){
    return state.username;
  }
};

// mutations
const mutations = {
  setRegisterErr(state, errors) {
    state.registerErr = errors;
  },
  setRememberMe(state, remember) {
    state.rememberMe = remember;
  },
  setAccessAndRefreshToken(state, tokens) {
    let expireTime = "24h";
    if (state.rememberMe) {
      expireTime = "1m";
    }
    VueCookies.set("ACCESS-TOKEN", tokens.access, "10min");
    VueCookies.set(
      "__HIRE-REFRESH-TOKEN",
      tokens.refresh,
      expireTime,
      null,
      null,
      true,
      "Strict"
    );
  },
  setIsAuthenticated(state) {
    state.IsAuthenticated = true;
  },
  setCheckRedirect(state){
    state.checkRedirect = true;
  },
  setNeedRedirect(state, redirect){
    state.needRedirect = redirect;
  },
  setRedirectUrl(state, url){
    state.redirectUrl = url;
  },
  cleanIsAuthenticated(state) {
    state.IsAuthenticated = false;
  },
  setLoginErr(state, errors) {
    state.loginErr = errors;
  },
  cleanCookies() {
    VueCookies.remove("ACCESS-TOKEN");
    VueCookies.remove("__HIRE-REFRESH-TOKEN");
  },
  setChangePassErr(state, errors) {
    state.changePassErr = errors;
  },
  setUserData(state, data) {
    state.userData = data;
  },
  setDarkMode(state, bool) {
    state.isDark = bool;
  },
  setAllUsers(state, users) {
    state.usersList = users;
  },
  setUsername(state, username){
    state.username = username;
  }
};

// actions
const actions = {

  registerUser({ commit, dispatch }, formData) {
    return axiosInstance
      .post("/account/register/", {
        username: formData.userName,
        mobile: formData.phoneNumber,
        password: formData.password,
        confirm_password: formData.confirmPassword,
      })
      .then(() => {
        state.registerErr = {};
        const loginForm = {
          userName: formData.userName,
          password: formData.password,
        }
        dispatch("loginUser", {loginForm, rememberMe: true});
      })
      .catch(error => {
        commit("setRegisterErr", error.response.data.detail);
      });
  },

  loginUser({ commit }, formData) {
    return axiosInstance
      .post("/auth/jwt/login/", {
        username: formData.loginForm.userName,
        password: formData.loginForm.password,
      })
      .then(response => {
        if(response.data.redirect_url){
          window.location.href = response.data.redirect_url;
        }
        else{
          commit("setRememberMe", formData.rememberMe);
          commit("setAccessAndRefreshToken", response.data);
          commit("setIsAuthenticated");
          router.push({ name: "dashboard", query:{ message: "welcome" }});
        }
      })
      .catch(error => {
        if (error.response.data.detail == "object") {
          commit("setLoginErr", error.response.data.detail);
        } else {
          toast.error(error.response.data.detail);
        }
      });
  },

  ForgetPassword({ }, formData) {
    return axiosInstance
      .post("/account/password/forget/", {
        username: formData.userName,
        mobile: formData.phoneNumber,
      })
      .then(() => {
        toast.success(`رمز عبور برای شما ارسال شد
            انتقال به صفحه ورود`);
        setTimeout(() => {
          router.push({ name: "login" });
        }, 3000);
      })
      .catch(error => {
        console.error(error);
        toast.error("کد ملی یا تلفن همراه یافت نشد");
      });
  },

  changePassUser({ commit }, formData) {
    return axiosInstance
      .post("/account/password/change/",
        {
          current_password: formData.currentPassword,
          new_password: formData.newPassword,
          confirm_new_password: formData.confirmPassword,
        },
      )
      .then(() => {
        toast.success("رمز عبور با موفقیت تغییر یافت");
        setTimeout(() => {
          router.push({ name: 'dashboard' });
        }, 2000);
      })
      .catch(error => {
        console.error(error);
        commit("setChangePassErr", error.response.data.detail);
      });
  },
  exitApp({ commit }, message) {
    commit("cleanIsAuthenticated");
    commit("cleanCookies");
    if (message)
      router.push({ name: "login", query: { message: message } });
    else
      router.push({ name: 'login' });
  },

  getAccessTokenFromRefreshToken({ dispatch }) {
    return axiosInstance
      .post("/auth/jwt/refresh/", {
        refresh: VueCookies.get("__HIRE-REFRESH-TOKEN"),
      })
      .then(response => {
        VueCookies.set("ACCESS-TOKEN", response.data.access, "10min");
      })
      .catch(error => {
        dispatch("exitApp", 'expired');
        throw error;
      });
  },

  getUserDataFromApi({ commit }, username) {
    return axiosInstance
      .get("/account/user/detail/", { params: { username } })
      .then(response => {
        commit("setUserData", response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },

  setDarkModeToLocaleStorage({ commit }, bool) {
    localStorage.setItem("dark-mode", bool);
    commit("setDarkMode", bool);
  },

  getAllUsers({ commit }, filters){
    return axiosInstance
      .get("/job/application/users/all", {
        params: {
          search: filters.search,
          page: filters.page,
          page_size: filters.page_size
        }
      })
      .then(response => {
        commit("setAllUsers", response.data)
      })
      .catch(error => {
        console.error(error);
        toast.error("لیست کاربران دریافت نشد. لطفا بعدا تلاش کنید.")
      })
  },

  getRedirectStatus({commit}){
    return axiosInstance.get("/account/official-token/get/").then((response)=>{
      commit("setNeedRedirect", response.data.redirect);
      commit("setRedirectUrl", response.data.redirect_url);
    }).catch((error)=>{
      console.error(error);
    })
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
};
